import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";


export type ReviewStat = { count: number; avg: number };

export function useReviewStats() {
  const { data } = useQuery({
    queryKey: ["review-stats"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("place_reviews_public" as any)
        .select("place_slug, rating");
      if (error) throw error;
      const map = new Map<string, { sum: number; count: number }>();
      for (const r of (data ?? []) as any[]) {
        const cur = map.get(r.place_slug) ?? { sum: 0, count: 0 };
        cur.sum += r.rating;
        cur.count += 1;
        map.set(r.place_slug, cur);
      }
      const stats: Record<string, ReviewStat> = {};
      map.forEach((v, k) => {
        stats[k] = { count: v.count, avg: v.count ? v.sum / v.count : 0 };
      });
      return stats;
    },
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    placeholderData: {},
  });

  return data ?? {};
}


export function useReviewStat(slug: string): ReviewStat {
  const stats = useReviewStats();
  return stats[slug] ?? { count: 0, avg: 0 };
}
